"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscriptions = subscriptions;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _underscore = require("underscore");

var INITIAL_STATE = {
  subscriptions: {
    isFetching: false,
    fetchingHasError: false,
    fetchingRecentError: undefined,
    isFetchingStatus: false,
    fetchingStatusHasError: false,
    fetchingStatusRecentError: undefined,
    isSaving: false,
    savingHasError: false,
    savingRecentError: undefined,
    subscriptionsByFormGuid: {},
    definitions: [],
    isFetchingDefinitions: false,
    fetchingDefinitionsHasError: false,
    fetchingDefinitionsRecentError: undefined
  }
};

function subscriptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE.subscriptions;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    // ESP SYNC LIST COUNTS
    case _ActionTypes.REQUEST_SUBSCRIPTION_STATUS:
      return Object.assign({}, state, {
        isFetchingStatus: true
      });

    case _ActionTypes.RECEIVE_SUBSCRIPTION_STATUS:
      {
        var object = {};
        object[action.meta.formGuid] = Object.assign({}, state.subscriptionsByFormGuid[action.meta.formGuid], action.payload);
        return Object.assign({}, state, {
          isFetchingStatus: false,
          fetchingStatusHasError: false,
          subscriptionsByFormGuid: Object.assign({}, state.subscriptionsByFormGuid, object)
        });
      }

    case _ActionTypes.ERROR_SUBSCRIPTION_STATUS:
      return Object.assign({}, state, {
        isFetchingStatus: false,
        fetchingStatusHasError: true,
        fetchingStatusRecentError: action.payload
      });
    // FULL ESP SYNC LISTS INFO

    case _ActionTypes.REQUEST_SUBSCRIPTIONS_BY_FORM_GUID:
      return Object.assign({}, state, {
        isFetching: true
      });

    case _ActionTypes.RECEIVE_SUBSCRIPTIONS_BY_FORM_GUID:
      {
        var _object = {};
        _object[action.meta.formGuid] = Object.assign({}, state.subscriptionsByFormGuid[action.meta.formGuid], {
          count: (0, _underscore.filter)(action.payload, function (item) {
            return item.syncEnabled;
          }).length,
          subscriptionsByEspListId: (0, _underscore.indexBy)(action.payload, 'espListId')
        });
        return Object.assign({}, state, {
          isFetching: false,
          fetchingHasError: false,
          subscriptionsByFormGuid: Object.assign({}, state.subscriptionsByFormGuid, _object)
        });
      }

    case _ActionTypes.ERROR_SUBSCRIPTIONS_BY_FORM_GUID:
      return Object.assign({}, state, {
        isFetching: false,
        fetchingHasError: true,
        fetchingRecentError: action.payload
      });
    // UPDATE SUBSCRIPTION

    case _ActionTypes.CHANGE_SUBSCRIPTION_STATUS:
      {
        var cloned = (0, _underscore.clone)(state.subscriptionsByFormGuid[action.payload.formGuid]);
        Object.assign(cloned.subscriptionsByEspListId[action.payload.espListId], {
          syncEnabled: action.payload.syncEnabled
        });
        return Object.assign({}, state, {
          subscriptionsByFormGuid: (0, _defineProperty2.default)({}, action.payload.formGuid, cloned)
        });
      }
    // SAVE CHANGES

    case _ActionTypes.SAVE_SUBSCRIPTIONS:
      return Object.assign({}, state, {
        isSaving: true
      });

    case _ActionTypes.SAVE_SUBSCRIPTIONS_SUCCESS:
      {
        var _cloned = (0, _underscore.clone)(state.subscriptionsByFormGuid[action.meta.formGuid]);

        var espLists = Object.values(_cloned.subscriptionsByEspListId || {});
        var countEnabled = (0, _underscore.filter)(espLists, function (list) {
          return list.syncEnabled;
        }).length; // Update all subscriptions with the id returned in the response

        (0, _underscore.each)(action.payload, function (subscription) {
          _cloned.subscriptionsByEspListId[subscription.espListId].id = subscription.id;
        });
        Object.assign(_cloned, {
          count: countEnabled
        });
        return Object.assign({}, state, {
          isSaving: false,
          subscriptionsByFormGuid: (0, _defineProperty2.default)({}, action.meta.formGuid, _cloned)
        });
      }

    case _ActionTypes.SAVE_SUBSCRIPTIONS_ERROR:
      return Object.assign({}, state, {
        isSaving: false,
        savingHasError: true,
        savingRecentError: action.payload
      });

    case _ActionTypes.RESET_SUBSCRIPTIONS:
      return Object.assign({}, state, {
        subscriptionsByFormGuid: []
      });
    // Subscriptions definitions

    case _ActionTypes.REQUEST_SUBSCRIPTIONS_DEFINITIONS:
      return Object.assign({}, state, {
        isFetchingDefinitions: true,
        fetchingDefinitionsHasError: false,
        fetchingDefinitionsRecentError: undefined
      });

    case _ActionTypes.RECEIVE_SUBSCRIPTIONS_DEFINITIONS:
      return Object.assign({}, state, {
        definitions: action.payload.subscriptionDefinitions,
        isFetchingDefinitions: false,
        fetchingDefinitionsHasError: false,
        fetchingDefinitionsRecentError: undefined
      });

    case _ActionTypes.ERROR_SUBSCRIPTIONS_DEFINITIONS:
      return Object.assign({}, state, {
        isFetchingDefinitions: false,
        fetchingDefinitionsHasError: true,
        fetchingDefinitionsRecentError: action.payload
      });

    default:
      return state;
  }
}